import React from 'react';
import { motion } from 'framer-motion';
import { Moon, AlertCircle, BatteryLow, Clock, Brain } from 'lucide-react';
const symptoms = [{
  icon: Clock,
  text: "Te duermes y a las 1–4am tu cuerpo te despierta 'de golpe'."
}, {
  icon: Brain,
  text: 'Tu mente se acelera con pensamientos repetidos y ansiedad.'
}, {
  icon: BatteryLow,
  text: 'Al día siguiente vives a base de café, irritabilidad y cansancio.'
}, {
  icon: Moon,
  text: "Te dices 'hoy sí me acuesto temprano'... y vuelve a pasar."
}, {
  icon: AlertCircle,
  text: "Te da rabia porque por fuera 'todo está bien', pero por dentro estás agotada."
}];
export function PainPoints() {
  return <section className="py-20 bg-white px-4" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-134">
            ¿Esto te está pasando?
          </h2>
          <div className="w-24 h-1 bg-[#0d9488] mx-auto rounded-full" data-id="element-135"></div>
        </motion.div>

        <div className="grid gap-6" data-id="element-136">
          {symptoms.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 rounded-xl bg-[#fef3e2]/50 border border-[#fef3e2] hover:border-[#0d9488]/30 transition-colors" data-id="element-137">
              <div className="bg-[#0d9488]/10 p-3 rounded-full shrink-0" data-id="element-138">
                <item.icon className="w-6 h-6 text-[#0d9488]" data-id="element-139" />
              </div>
              <p className="text-lg text-slate-700 font-medium pt-1" data-id="element-140">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-center bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-141">
          <p className="text-xl text-slate-800 font-serif italic" data-id="element-142">
            "Si te identificas, no necesitas más consejos sueltos. Necesitas un
            sistema que funcione{' '}
            <span className="font-bold text-[#0d9488]" data-id="element-143">
              cuando estás cansada
            </span>
            , no cuando estás motivada."
          </p>
        </motion.div>
      </div>
    </section>;
}